import { get, post } from '@/base/http-base'
//获取可用代金券
export function getCouponUseMsg(params, target) {
  return get('/localAPI/coupon/describeCoupons', params, target)
}

//校验权限
export function checkPermission(params) {
  return get('/localAPI/couponQuota/checkPermission', params, {
    isLoading: false
  })
}

//获取验证码
export function getMobileCodeInfo(params) {
  return get('/localAPI/account/describeVerificationCode', params, {
    isLoading: false
  })
}

//激活代金券
export function activeCoupon(params) {
  return post('/localAPI/coupon/activeCoupon', params, {
    target: '.form-loading'
  })
}

//获取代金券使用明细
export function couponDetail(params) {
  return get('/localAPI/coupon/describeCoupon', params, {
    target: '.detail-table'
  })
}

//校验是否有权限查看券额管理页面
export function queryQuota(params) {
  return get('/localAPI/couponQuota/queryQuota', params, {
    target: '.couponLoading'
  })
}

//请求券额额度列表
export function queryQuotaRecordList(params) {
  return post('/localAPI/couponQuota/queryQuotaRecordList', params, {
    target: '.quotaLoading'
  })
}

//请求券额发放列表
export function queryCouponList(params) {
  return get('/localAPI/couponQuota/queryCouponList', params, {
    target: '.grantLoading'
  })
}

//校验pin
export function pinValidate(params) {
  return post('/localAPI/couponQuota/pinValidate', params, {
    isLoading: false
  })
}

//发放代金券
export function deliverCoupon(params) {
  return post('/localAPI/couponQuota/deliverCoupon', params, {
    target: '.diliverButton'
  })
}

//判断用户是否有发放代金券的权限
export function queryValidTime(params) {
  return get('/localAPI/couponQuota/queryValidTime', params, {
    isLoading: false
  })
}

//禁用代金券
export function disableCoupons(params) {
  return post('/localAPI/couponQuota/disableCoupons', params, {
    isLoading: false
  })
}

// //发放记录导出
// export function exportCouponList(params) {
//   return get('/localAPI/couponQuota/exportCouponList', params, {
//     isLoading: false
//   })
// }

// 我的客户
export function queryMyCustomerList(params) {
  return get('/localAPI/distributor/queryMyCustomerList', params, {
    isLoading: false
  })
}

// 我的渠道商
export function getSubDistributorList(params) {
  return get('/localAPI/distributor/getSubDistributorList', params, {
    isLoading: false
  })
}

// 渠道商客户
export function querySubCustomerList(params) {
  return get('/localAPI/distributor/querySubCustomerList', params, {
    isLoading: false
  })
}

/**
 *
 * 新版券额接口开始
 */
// 控制台查询券额记录接口
export function describeConsoleQuotaRecord(params) {
  return get('/localAPI/quotaCoupon/describeConsoleQuotaRecord', params, {
    target: '.quotaRecordList'
  })
}

// 控制台查询券额信息接口
export function queryConsoleQuotaInfo(params) {
  return get('/localAPI/quotaCoupon/queryConsoleQuotaInfo', params, {
    target: '.couponLoading'
  })
}

// 控制台查询券额操作记录接口(详情页)
export function queryConsoleQuotaRecordList(params) {
  return get('/localAPI/quotaCoupon/queryConsoleQuotaRecordList', params, {
    target: '.couponLoading'
  })
}

// 控制台发放代金券接口
export function consoleDeliverCoupon(params) {
  return post('/localAPI/quotaCoupon/consoleDeliverCoupon', params, {
    target: '.issue'
  })
}

// 控制台券额转赠接口
export function quotaResend(params) {
  return post('/localAPI/quotaCoupon/quotaResend', params, {
    target: '.issue'
  })
}

// 控制台获取券额额度值
export function quotaValue(params) {
  return get('/localAPI/quotaCoupon/quotaValue', params, {
    target: '.money-top'
  })
}

// 控制台查询发放记录接口(券额管理页面)
export function queryConsoleDeliverRecordList(params) {
  return get('/localAPI/quotaCoupon/queryConsoleDeliverRecordList', params, {
    target: '.grantLoading'
  })
}

// 控制台发送短信验证码
export function sendValidateCode(params) {
  return get('/localAPI/quotaCoupon/sendValidateCode', params, {
    target: '.code'
  })
}

// 控制台查询用户手机号
export function describeBaseInfo(params) {
  return get('/localAPI/quotaCoupon/describeBaseInfo', params, {
    target: '.grantLoading'
  })
}

// 控制台查询用户使用新版还是旧版
export function getConsoleVersion(params) {
  return get('/localAPI/quotaCoupon/getConsoleVersion', params, {
    target: '.mainCon'
  })
}

// 券额券详情页 禁用代金券
export function consoleDisableCoupon(params) {
  return get('/localAPI/quotaCoupon/consoleDisableCoupon', params, {
    target: '.dialogDisable'
  })
}
// 券额券详情页 禁用券额券
export function consoleDisableQuota(params) {
  return get('/localAPI/quotaCoupon/consoleDisableQuota', params, {
    target: '.dialogDisable'
  })
}

// 获取安全校验
export function describeConsoleSecurity(params) {
  return get('/localAPI/quotaCoupon/describeConsoleSecurity', params, {
    target: '.dialogDisable'
  })
}
// 代金券详情导出
export function exportExcel(params) {
  return get('/openApi/coupon/exportExcel', params, {
    target: '.dialogDisable'
  })
}
//代金券操作详情
export function describeCoupon(params) {
  return get('/openApi/coupon/describeCoupon', params, {
    target: '.dialogDisable'
  })
}

/**
 *
 * 新版券额接口结束
 */
